import { EmailDraftT } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { EmailDraftV2, FormValues } from './composeEmailModal.types';

type EmailUser = { user: User & { display_name?: string | null } };
const convertEmailUserToEmail = (emailUser: EmailUser) => {
  return {
    email: emailUser.user.email || '',
    name: emailUser.user.name || '',
  };
};

/** Convert FormValues to EmailDraftV2 for saving to server storage. */
export const convertFormValuesToEmailDraftV2 = (
  values: FormValues,
  timestamp: number,
): EmailDraftV2 => {
  const { includeInternalNote: _, ...rest } = values;
  return { ...rest, timestamp };
};

/**
 * Convert EmailDraftV2 from server storage to FormValues for pre-populating the
 * form.
 */
export const convertEmailDraftV2ToFormValues = (
  draft: EmailDraftV2,
): Partial<FormValues> => ({
  ...draft,
  includeInternalNote: draft.internalNote.length > 0,
});

/**
 * Convert from draft email to formValues once the old modal is phased out, we
 * can convert the draft format to better fit our formValues, and so we should
 * not need to convert at that point
 */
export const convertDraftToFormValues = (
  draft: EmailDraftT | undefined,
): Partial<FormValues> => {
  if (!draft) return {};

  const values: Partial<FormValues> = {};
  if (draft.toUser && draft.toUser[0]) {
    values.toEmail = [
      {
        email: draft.toUser[0].user.email || '',
        name: draft.toUser[0].user.name || '',
      },
    ];
  }
  if (draft.fromEmails) {
    values.fromEmail = [draft.fromEmails];
  }
  if (draft.cc) {
    values.cc = draft.cc.map(convertEmailUserToEmail);
  }
  if (draft.bcc) {
    values.bcc = draft.bcc.map(convertEmailUserToEmail);
  }
  if (draft.subject) {
    values.subject = draft.subject;
  }
  if (draft.message) {
    values.body = draft.message;
  }
  if (draft.internalNote) {
    values.internalNote = draft.internalNote;
  }
  if (draft.tags) {
    values.tags = draft.tags;
  }

  if (draft.queue) {
    values.queueId = [draft.queue.id];
  }
  if (draft.offer) {
    values.offerInQueue = draft.offer;
  }

  return values;
};
